import { ResourceBaseService } from "@/core/common/resource-base/resource-base.service";
import { ApiHttpClient } from "@/core/common/http/api-http-client";
import { HttpRequest } from "@/core/common/http/http-request";
import { plainToInstance } from "class-transformer";
import { ChatHistoryDto } from "./chat-history.dto";
import { AskQuestionDto } from "./ask-question.dto";
import { ConversationSummaryDto } from "./conversation-summary.dto";

export class AiChatResource extends ResourceBaseService<ChatHistoryDto, AskQuestionDto, unknown> {
  protected EntityDto = ChatHistoryDto;
  protected CreateEntityDto = AskQuestionDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/ai-chat");
  }

  async askQuestion(dto: AskQuestionDto): Promise<{
    status: string;
    jobId: string;
  }> {
    return this.apiHttpClient.request<
      AskQuestionDto,
      {
        status: string;
        jobId: string;
      }
    >(
      HttpRequest.create({
        url: this.resourceUrl + "/ask",
        method: "POST",
        auth: true,
        body: dto,
      })
    );
  }

  async getHistory(limit = 50): Promise<ChatHistoryDto[]> {
    return this.apiHttpClient
      .request<ChatHistoryDto[], ChatHistoryDto[]>(
        HttpRequest.create({
          url: this.resourceUrl + "/history?limit=" + limit,
          auth: true,
        })
      )
      .then((answer) => plainToInstance(ChatHistoryDto, answer));
  }

  async getConversations(limit = 20): Promise<ConversationSummaryDto[]> {
    return this.apiHttpClient
      .request<ConversationSummaryDto[], ConversationSummaryDto[]>(
        HttpRequest.create({
          url: this.resourceUrl + "/conversations?limit=" + limit,
          auth: true,
        })
      )
      .then((answer) => plainToInstance(ConversationSummaryDto, answer));
  }

  async getConversationMessages(conversationId: string): Promise<ChatHistoryDto[]> {
    return this.apiHttpClient
      .request<ChatHistoryDto[], ChatHistoryDto[]>(
        HttpRequest.create({
          url: this.resourceUrl + "/conversations/" + conversationId,
          auth: true,
        })
      )
      .then((answer) => plainToInstance(ChatHistoryDto, answer));
  }

  async downloadChatPdf(chatHistoryId: string): Promise<Blob> {
    const response = await fetch(this.apiHttpClient["baseUrl"] + this.resourceUrl + "/download-pdf/" + chatHistoryId, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + (await this.apiHttpClient["authStoreService"].getToken()),
      },
    });

    if (!response.ok) {
      throw new Error("Error al descargar el PDF");
    }

    return response.blob();
  }

  async downloadChatExcel(chatHistoryId: string): Promise<Blob> {
    const response = await fetch(
      this.apiHttpClient["baseUrl"] + this.resourceUrl + "/download-excel/" + chatHistoryId,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + (await this.apiHttpClient["authStoreService"].getToken()),
        },
      }
    );

    if (!response.ok) {
      throw new Error("Error al descargar el Excel");
    }

    return response.blob();
  }
}
